export default [
  {
    path: "",
    requireAuth: true,
    permissions: []
  },
  {
    path: "/404",
    requireAuth: true,
    permissions: []
  },
  {
    path: "/admin",
    requireAuth: true,
    permissions: ["read:admin"]
  },
  {
    path: "/admin/account",
    requireAuth: true,
    permissions: ["read:admin"]
  },
  {
    path: "/admin/applications",
    requireAuth: true,
    permissions: ["read:admin", "read:applications"]
  },
  {
    path: "/admin/billing",
    requireAuth: true,
    permissions: ["read:admin", "read:billing"]
  },
  {
    path: "/admin/users",
    requireAuth: true,
    permissions: ["read:admin", "read:users"]
  },
  {
    path: "/auth",
    requireAuth: false,
    permissions: []
  },
  {
    path: "/auth/support",
    requireAuth: false,
    permissions: []
  },
  {
    path: "/clients",
    requireAuth: true,
    permissions: ["read:clients"]
  },
  {
    path: "/clients/new",
    requireAuth: true,
    permissions: ["create:clients"]
  },
  {
    path: "/clients/:id",
    requireAuth: true,
    permissions: ["read:clients"]
  },
  {
    path: "/clients/:id/edit",
    requireAuth: true,
    permissions: ["update:clients"]
  },
  {
    path: "/dashboard",
    requireAuth: true,
    permissions: ["read:dashboard"]
  },
  {
    path: "/edits",
    requireAuth: true,
    permissions: ["read:edits"]
  },
  {
    path: "/edits/new",
    requireAuth: true,
    permissions: ["create:edits"]
  },
  {
    path: "/edits/:id",
    requireAuth: true,
    permissions: ["read:edits"]
  },
  {
    path: "/edits/:id/edit",
    requireAuth: true,
    permissions: ["update:edits"]
  },
  {
    path: "/locations",
    requireAuth: true,
    permissions: ["read:locations"]
  },
  {
    path: "/locations/new",
    requireAuth: true,
    permissions: ["create:locations"]
  },
  {
    path: "/locations/:id",
    requireAuth: true,
    permissions: ["read:locations"]
  },
  {
    path: "/locations/:id/edit",
    requireAuth: true,
    permissions: ["update:locations"]
  },
  {
    path: "/maps",
    requireAuth: true,
    permissions: ["read:maps"]
  },
  {
    path: "/maps/new",
    requireAuth: true,
    permissions: ["create:maps"]
  },
  {
    path: "/maps/:id",
    requireAuth: true,
    permissions: ["read:maps"]
  },
  {
    path: "/maps/:id/edit",
    requireAuth: true,
    permissions: ["update:maps"]
  },
  {
    path: "/maps/:id/public",
    requireAuth: false,
    permissions: []
  },
  {
    path: "/partners",
    requireAuth: true,
    permissions: ["read:super"]
  },
  {
    path: "/partners/new",
    requireAuth: true,
    permissions: ["create:super"]
  },
  {
    path: "/partners/:id",
    requireAuth: true,
    permissions: ["read:super"]
  },
  {
    path: "/partners/:id/edit",
    requireAuth: true,
    permissions: ["update:super"]
  },
  {
    path: "/projects",
    requireAuth: true,
    permissions: ["read:projects"]
  },
  {
    path: "/projects/new",
    requireAuth: true,
    permissions: ["create:projects"]
  },
  {
    path: "/projects/:id",
    requireAuth: true,
    permissions: ["read:projects"]
  },
  {
    path: "/projects/:id/edit",
    requireAuth: true,
    permissions: ["update:projects"]
  },
  {
    path: "/cameras",
    requireAuth: true,
    permissions: ["read:cameras"]
  },
  {
    path: "/cameras/new",
    requireAuth: true,
    permissions: ["create:super"]
  },
  {
    path: "/cameras/:id",
    requireAuth: true,
    permissions: ["read:cameras"]
  },
  {
    path: "/cameras/:id/edit",
    requireAuth: true,
    permissions: ["update:cameras"]
  },
  {
    path: "/support",
    requireAuth: false,
    permissions: []
  },
  {
    path: "/user",
    requireAuth: true,
    permissions: []
  },
  {
    path: "/user/profile",
    requireAuth: true,
    permissions: ["read:profile"]
  },
  {
    path: "/user/settings",
    requireAuth: true,
    permissions: ["update:profile"]
  },
  {
    path: "/users",
    requireAuth: true,
    permissions: ["read:users"]
  },
  {
    path: "/users/new",
    requireAuth: true,
    permissions: ["create:users"]
  },
  {
    path: "/users/:id",
    requireAuth: true,
    permissions: ["read:users"]
  },
  {
    path: "/users/:id/edit",
    requireAuth: true,
    permissions: ["update:users"]
  },
  {
    path: "/views",
    requireAuth: true,
    permissions: ["read:views"]
  },
  {
    path: "/views/new",
    requireAuth: true,
    permissions: ["create:views"]
  },
  {
    path: "/views/:id",
    requireAuth: true,
    permissions: ["read:views"]
  },
  {
    path: "/views/:id/edit",
    requireAuth: true,
    permissions: ["update:views"]
  },
  {
    path: "/videos",
    requireAuth: true,
    permissions: ["read:videos"]
  },
  {
    path: "/videos/new",
    requireAuth: true,
    permissions: ["create:videos"]
  },
  {
    path: "/videos/:id",
    requireAuth: true,
    permissions: ["read:videos"]
  },
  {
    path: "/videos/:id/edit",
    requireAuth: true,
    permissions: ["update:videos"]
  }
]